import { app } from './app';
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions';

const functions = getFunctions(app);
// connectFunctionsEmulator(functions, 'localhost', 5001);

export const createParty = httpsCallable<undefined, { result: string }>(functions, 'createParty');
